export default {
  translation: {
    regionPicker: {
      chooseArea: 'Choisissez votre région'
    },
    configurator: {
      configureNow: 'Configurer ma poignée !',
      chooseFrameColor: 'Choisissez la couleur de votre châssis',
      chooseHandle: 'Choisissez le modèle que vous souhaitez configurer',
      createYourOwnButton: 'Créer ma poignée personnalisée',
      createYourOwn: 'Téléchargez un fichier',
      sendConfig: 'Sauvegarder cette poignée',
      colorType: {
        ral: 'Laqué',
        anodized: 'Anodisé',
        decor: 'Décoratif',
        custom: 'Personnalisé'
      },
      color: {
        black: 'Noir',
        white: 'Blanc'
      },
      form: {
        myConfig: 'Sauvegarder ma poignée personnalisée',
        send: 'Envoyer !',
        success: 'Votre configuration vous a été envoyée par e-mail avec succès !',
        error: 'Une erreur est survenue lors de l\'envoi de votre e-mail !',
        model: 'Modèle de poignée',
        color: 'Couleur',
        ornament: 'Décors',
        ornament_color: 'Couleur du décors',
        custom: 'Poignée personnalisée'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/i18n/fr.js